/**
 * @desc 报告类型列表
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/platformReport/reportList`, {
      method: "GET",

      ...options,
    }),
  );
}
